import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Promise from 'bluebird';
import moment from 'moment-timezone';
import { getLargestAvailableCoupon } from '../helpers';
import { getNextGoalAmount } from '../../redux/helpers';

// Pages
import AddCouponPage from './containers/AddCouponPage';
import HasCouponPage from './containers/HasCouponPage';

// Event Listener
import escEventListener from '../../eventListeners/escListener';

/*
  NOTE: lifetime use is not being shown because it is not in /balance or the main feed
*/

class AccountPage extends Component {

  static propTypes = {
    // Required
    cardNumber: PropTypes.string.isRequired,
    cardAmount: PropTypes.number.isRequired,
    bufferAmount: PropTypes.number.isRequired,
    // goalAmount: PropTypes.number.isRequired,
    lifetimeAmount: PropTypes.number.isRequired,
    getCardBalance: PropTypes.func.isRequired,
    couponExpirationDate: PropTypes.string
  }

  state = {
    isPopupOpen: false,
    isBalanceLoaded: false,
  }

  // Used for Expiration Date
  months = [
    'January', 'February', 'March', 'April', 'May',
    'June', 'July', 'August', 'September', 'October',
    'November', 'December'
  ];

  componentDidMount() {
    const {
      setLoading,
      getCardBalance,
      history
    } = this.props;

    setLoading(false);

    Promise.resolve()
    // 3 second delay to wait for db to
    // resolve any recently completed engagements
    .then(() => setTimeout(() => {
      getCardBalance().then(() => this.setState({ isBalanceLoaded: true }));
    }, 3500))
    .catch(err => {
      setLoading(false);
      this.setState({ isBalanceLoaded: true });
      console.error(err);
    });

    this.removeEscEventListener = escEventListener(() => history.push('/app/campaigns'));

    // scroll to top of page
    window.scrollTo(0,0);
  }

  componentWillUnmount() {
    this.removeEscEventListener();
  }

  togglePopup() {
    this.setState({ isPopupOpen: !this.state.isPopupOpen });
  }

  handleAddToCard(couponAmt) {
    const {
      requestCoupon,
    } = this.props;

    requestCoupon(couponAmt); // Adjoy API
  }

  handleWaitUntilNextGoal() {
    const {
      bufferAmount,
      goalAmount,
      setGoalAmount
    } = this.props;

    if (bufferAmount >= goalAmount) {
      setGoalAmount(getNextGoalAmount(bufferAmount));
    }
  }

  render() {
    const {
      cardNumber,
      bufferAmount,
      cardAmount,
      couponExpirationDate,
      // lifetimeAmount
    } = this.props;

    const {
      isPopupOpen,
      isBalanceLoaded
    } = this.state;

    const shortCardNum = String(cardNumber).substring(0, 11); // only first 11 digits
    const addBtnDisabled = (cardAmount > 0 || (bufferAmount < 1)) ? true : false;
    const couponExpDate = moment.tz(couponExpirationDate, 'America/New_York');
    const finalCouponExpDate = (
      this.months[couponExpDate.month()]
      + ' '
      + couponExpDate.date()
      + ', ' + couponExpDate.year()
    );

    if (cardAmount <= 0) {
      return (
        <AddCouponPage
          isBalanceLoaded={isBalanceLoaded}
          cardNumber={shortCardNum}
          bufferAmount={bufferAmount}
          goalAmount={getLargestAvailableCoupon(bufferAmount)}
          addBtnDisabled={addBtnDisabled}
          onAddBtnClick={(couponAmt) => this.handleAddToCard(couponAmt)}
          isPopupOpen={isPopupOpen}
          onTogglePopup={() => this.togglePopup()}
        />
      );
    } else {
      return (
        <HasCouponPage
          cardNumber={shortCardNum}
          cardAmount={cardAmount}
          couponExpirationDate={finalCouponExpDate}
          isPopupOpen={isPopupOpen}
          onTogglePopup={() => this.togglePopup()}
        />
      );
    }
  }
}

export default AccountPage;



// WEBPACK FOOTER //
// ./src/pages/Account/Account.js